import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Facebook, Instagram, Youtube } from 'lucide-react';

const LOGO_SRC = '/img/logo_gross.png';

export default function Footer() {
  const [logoOk, setLogoOk] = useState(true);
  return (
    <footer className="bg-spin-dark text-white">
      <div className="max-w-6xl mx-auto px-5 py-14 grid md:grid-cols-4 gap-10">
        <div>
          {logoOk ? (
            <img
              src={LOGO_SRC}
              alt="Spinsafe"
              className="h-10 w-auto mb-3 brightness-0 invert"
              onError={() => setLogoOk(false)}
            />
          ) : (
            <h4 className="font-heading font-bold text-lg mb-3">spinsafe</h4>
          )}
          <p className="text-sm text-white/70 leading-relaxed">
            Der Outdoor-Tresor für deine Wertsachen am See, im Park, im Freibad oder beim Festival.
          </p>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-sm uppercase tracking-wider mb-3 text-spin-green-light">
            Spinsafe
          </h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><a href="/#workflow" className="hover:text-spin-green-light transition-colors">So funktioniert's</a></li>
            <li><a href="/#features" className="hover:text-spin-green-light transition-colors">Funktionen</a></li>
            <li><a href="/#faq" className="hover:text-spin-green-light transition-colors">Häufige Fragen</a></li>
            <li><a href="/#team" className="hover:text-spin-green-light transition-colors">Über uns</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-sm uppercase tracking-wider mb-3 text-spin-green-light">
            Rechtliches
          </h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/howto" className="hover:text-spin-green-light transition-colors">How To</Link></li>
            <li><Link to="/datenschutz" className="hover:text-spin-green-light transition-colors">Datenschutz</Link></li>
            <li><Link to="/impressum" className="hover:text-spin-green-light transition-colors">Impressum</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-sm uppercase tracking-wider mb-3 text-spin-green-light">
            Folge uns
          </h4>
          <div className="flex gap-3">
            <a href="https://web.facebook.com/thespinsafe" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-spin-green transition-colors" aria-label="Facebook">
              <Facebook size={18} />
            </a>
            <a href="https://instagram.com/thespinsafe" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-spin-green transition-colors" aria-label="Instagram">
              <Instagram size={18} />
            </a>
            <a href="https://youtube.com/channel/UCwVazbaXwbS-S8AhqT4xGrw" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-spin-green transition-colors" aria-label="Youtube">
              <Youtube size={18} />
            </a>
            <a href="mailto:info@spinsafe.de" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-spin-green transition-colors" aria-label="E-Mail">
              <Mail size={18} />
            </a>
          </div>
          <a href="mailto:info@spinsafe.de" className="block mt-4 text-sm text-white/70 hover:text-white">
            info@spinsafe.de
          </a>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-5 py-5 text-xs text-white/50 flex flex-col md:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Spinsafe · Zeitfrei GmbH – Alle Rechte vorbehalten.</span>
          <span>Made in Germany</span>
        </div>
      </div>
    </footer>
  );
}
